import { homebarSideNavigationResource } from '@townsquare/home-layout/resources';
import Loadable from '@townsquare/loadable';
import { searchRoute } from '@townsquare/routes/search';

const SearchView = Loadable({
  loader: () => import(/* webpackChunkName: "search-view" */ './SearchView'),
  loading: () => null,
});

searchRoute.component = SearchView;
searchRoute.resources = [homebarSideNavigationResource];
export const searchRouterRoute = searchRoute;
